module.exports = __webpack_public_path__ + "static/high-performance-aa13bc0c13a45f702cc3db5b2a3b2a5b.png";